import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from './AuthContext'
import { Preloader } from '@/components/Preloader'

/**
 * Client-side [Authorize].
 *
 * The cookie middleware redirected anonymous users to
 * `/Account/Login?ReturnUrl=<original>`; the same URL is produced here so a user
 * who signs in lands back where they were. Nothing is trusted to this component
 * — every protected endpoint answers 401 on its own — it only avoids rendering
 * a page that would immediately fail.
 */
export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) return <Preloader />

  if (!isAuthenticated) {
    const returnUrl = `${location.pathname}${location.search}`
    return <Navigate to={`/Account/Login?ReturnUrl=${encodeURIComponent(returnUrl)}`} replace />
  }

  return <>{children}</>
}
